export const version = "6.0.2";
export const major = Number("6");
export const minor = Number("0");
export const patch = Number("2");
export const preReleaseLabel = undefined || null;
export const preReleaseNumber = Number(undefined) || null;
export default version;